<div id="main" class="myw-content d-flex flex-column flex-fill">
  <div class="iom-section iom-sub-section iom-section-category">
    <div class="row flex-lg-nowrap mb-2 mb-lg-4 align-items-center">
      <div class="col-12 col-lg mb-3 iom-review-list">
        <ul class="iom-review">
          <li>Ticket considered in one category, will not be considered in another category</li>
          <li>Please click on Recategorize button to make changes reflect in the dashboard</li>
          <li>
            User would be unable to edit the subcategories if any of the categories are being edited, until
            the completion of Recategorize. Vice-versa also applies.
          </li>
        </ul>
      </div>
      <div [ngClass]="{'col-12': true, 'pt-3':true, 'col-lg-auto':true, 'text-nowrap':true, 'pt-lg-2':true}">
        <a *ngIf="this.iomservice.readonlyDD == false" (click)="loadNewCategory()"
           [ngClass]="{'disabled':disableNewCategory}" class="btn btn-secondary">
          <span class="text-nowrap">Create New Category</span>
        </a>
        <a *ngIf="this.iomservice.readonlyDD == true" class="btn btn-secondary disabled">
          <span class="text-nowrap">Create New Category</span>
        </a>
        <button *ngIf="this.iomservice.readonlyDD == false" type="button" class="btn btn-secondary ml-3"
                [attr.disabled]="disableIgnoreModal == true ? 'disabled' : null" data-bs-toggle="modal"
                data-bs-target="#ignoreModal" (click)="LoadIgnoreKeywords()">
          <span class="text-nowrap">Ignore Keywords</span>
        </button>
        <button *ngIf="this.iomservice.readonlyDD == true" type="button" class="btn btn-secondary ml-3 disabled"
                data-bs-toggle="modal" data-bs-target="#ignoreModal" (click)="LoadIgnoreKeywords()">
          <span class="text-nowrap">Ignore Keywords</span>
        </button>
      </div>
    </div>
    <div class="row mb-3 mb-lg-3">
      <div class="col-4 col-lg">
        <div class="form-group">
          <label class="form-label" style="width: 14rem;">Classification Model</label>
          <input type="text" class="form-control-plaintext" value="{{ClassificationType}}" readonly />
        </div>
      </div>
      <div *ngIf="ClassificationTypeId == 2" class="col-4 col-lg">
        <div class="form-group">
          <label class="form-label" style="width: 8rem;">No of Cluster</label>
          <input type="text" [readonly]="EditCluster" (keyup)="OnKeyupClusters()" class="form-control"
                 [(ngModel)]="NoofCluster" value="{{NoofCluster}}" placeholder="Enter No of Cluster" />
        </div>
      </div>
      <div *ngIf="ClassificationTypeId == 2" class="col-4 col-lg">
        <!-- <div *ngIf="userType != 3" class="form-group">
          <label class="form-label">Exit Criteria</label>
          <input type="text" [readonly]="EditExitcondition" class="form-control"
                 (keyup)="OnKeyupExitCondition(false)" [(ngModel)]="ExitCondition" value="{{ExitCondition}}"
                 placeholder="Enter Exit Criteria" />
        </div> -->
        <div class="form-group">
          <label class="form-label" style="width: 18rem;">Allowed max % of unclassified tickets</label>
          <input type="text" [readonly]="EditExitcondition" class="form-control"
                 (keyup)="OnKeyupExitCondition(true)" [(ngModel)]="ExitCondition" value="{{ExitCondition}}"
                 placeholder="Enter allowed max % of unclassified tickets" />
        </div>
      </div>
      <div class="col-12 col-lg-auto align-self-end">
        <div class="form-group">
          <label class="myw-checkbox">
            <input #LemmaCheckbox id="LemmaCheckbox" type="checkbox" 
            [checked]="IsLemmaEnabled"
            [disabled]="LemmaDisableLR || disLemma"
            (change)="LemmaCheck(LemmaCheckbox.checked)"
            name="data-qo">
            <span>Lemmatization&nbsp;&nbsp;&nbsp;</span>
          </label>   
          <button type="button" class="btn btn-secondary iom-svg-icon" [disabled]="!IsProcessEnabled"
                  (click)="Recategorize()">
            <span class="text-nowrap">Re Categorize</span>
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div *ngIf="!isLoadNewCategory" class="iom-section-category-inner" [ngClass]="{active: !isLoadNewCategory}">
      <div class="iom-section-category-inner">
        <div class="iom-category-row iom-category-row-head">
          <div class="iom-category-col iom-category-cb">&nbsp;</div>
          <div class="iom-category-col iom-category-toggle">&nbsp;</div>
          <div class="iom-category-col iom-category-category myw-normal">Category</div>
          <div class="iom-category-col iom-category-ticket">Ticket Count</div>
          <div class="iom-category-col iom-category-key">Keywords Considered</div>
          <div class="iom-category-col iom-category-exclude">Keywords Excluded</div>
          <div class="iom-category-col iom-category-tat">
            <span style="padding-left: 20px;">TAT </span>
            <span style="font-size: 11px;
                    white-space: nowrap;">(Median Hrs)</span>
          </div>
          <div class="iom-category-col iom-category-dashboard">Dashboard</div>
          <div class="iom-category-col iom-category-option">&nbsp;</div>
        </div>
        <div *ngIf="NoData" style="text-align: center;font-size: 15px;font-weight: bold;padding-top: 25px;">
          There are no categories for this
          selected Language
        </div>
        <div class="parentdivcategory" [ngClass]="{'d-none':NoData}"
             *ngFor="let categoryObj of TicketCatagories">
          <div class="iom-category" id="Category_{{categoryObj.CateId}}">
            <div class="iom-category-row iom-category-head">
              <div class="iom-category-col iom-category-cb invisible">
                <label class="myw-checkbox myw-inline">
                  <input type="checkbox"
                         [attr.disabled]="categoryObj.CategoryType == 'Standard' ? 'disabled' : null"
                         [attr.title]="categoryObj.CategoryType == 'Standard' ? 'Standard category cannot be combined' : ''"
                         (change)="SelectobjectForMerge($event, true, categoryObj.CateId, 0, false)"
                         name="category-option" />
                  <span [attr.title]="categoryObj.CategoryType == 'Standard' ? 'Standard category cannot be combined' : ''"></span>
                </label>
              </div>
              <div id="catExp_{{categoryObj.CateId}}" (click)="ToggleCategory($event,categoryObj.CateId)"
                   style="cursor: pointer;" class="iom-category-col iom-category-toggle">
                <a title="Expand/Collapse"><span class="sr-only">Expand/Collapse</span></a>
              </div>
              <div class="iom-category-col iom-category-category" title="{{categoryObj.CategoryType}}">
                {{categoryObj.CategoryName}}
              </div>
              <div class="iom-category-col iom-category-ticket">
                <div class="iom-ticket-info">
                  <span>{{categoryObj.Percentage}}%</span>
                  <span>{{formatNumber(categoryObj.TicketCount)}}<br />Tickets</span>
                </div>
              </div>
              <div class="iom-category-col iom-category-key" style="width:100%; height: 75px;" ellipsis
                   title="{{categoryObj.IncludedKeyWords}}">{{categoryObj.IncludedKeyWords}}</div>
              <div class="iom-category-col iom-category-exclude" style="width:100%; height: 75px;"
                   ellipsis title="{{categoryObj.ExcludedKeyWords}}">{{categoryObj.ExcludedKeyWords}}</div>
              <div class="iom-category-col iom-category-tat">
                <span style="padding-left: 30px;">{{categoryObj.TATCat}}</span>
              </div>
              <div class="iom-category-col iom-category-dashboard">
                <label class="myw-flip">
                  <input *ngIf="categoryObj.TicketCount > 0" type="checkbox" class="dashboardtoggle"
                         (change)="ChangeDashboardFlag($event, categoryObj.CateId, categoryObj.CategoryName, categoryObj.TicketCount)"
                         [checked]="categoryObj.IsDashboardEnabled" [disabled]="IsFDSReadonly"
                         [value]="categoryObj.IsDashboardEnabled" /><input *ngIf="categoryObj.TicketCount == 0" type="checkbox" class="dashboardtoggle"
                                                                           checked="false" disabled value="false" /><span></span>
                </label>
              </div>
              <div *ngIf="categoryObj.CategoryType == 'Kmeans' || !IsKmeans"
                   class="iom-category-col iom-category-option novisibility mx-auto">
                <div class="dropdown dropright dropflat d-inline-block">
                  <a *ngIf="ClassificationType != 'Logistic Regression'" [ngClass]="{'d-inline-block': isCatOptionsEnabled}"
                     class="d-inline-block d-flex ml-auto" (click)="EnableDisableMerge(categoryObj.CateId)"
                     [ngStyle]="{'visibility': (isCatOptionsEnabled ? 'visible' : 'hidden')}"
                     role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                     aria-expanded="false" title="More Options">
                    <img src="assets/images/three-dot.svg" style="cursor: pointer;"
                         alt="More Options" class="myw-icon myw-24" style="cursor: pointer;" />
                    <span class="sr-only">More Options</span>
                  </a>
                  <div class="iom-dropdwn dropdown-menu">
                    <div class="dropdown-body">
                      <a [ngClass]="{'disabled':(categoryNameEditOnly || IsKmeans || (categoryObj.CategoryType == 'Standard'))}"
                         [attr.title]="categoryObj.CategoryType == 'Standard' ? 'Standard category cannot be combined' : ''"
                         (click)="TriggerMerge($event, true, categoryObj.CateId, 0)"
                         class="dropdown-item iom-category-merge iom-svg-icon">
                        <img src="assets/images/merge.svg" alt="" class="myw-icon myw-14" />
                        <span>Merge</span>
                      </a>
                      <a [ngClass]="{'disabled':(categoryNameEditOnly || IsKmeans)}"
                         (click)="TriggerSplit($event, true, categoryObj.CateId, 0)"
                         class="dropdown-item iom-category-split iom-svg-icon">
                        <img src="assets/images/split.svg" alt="" class="myw-icon myw-14" />
                        <span>Split</span>
                      </a>
                      <a [ngClass]="{'disabled': selectedLangAll}"
                      (click)="TriggerEdit($event, true, categoryObj.CateId, 0)"
                         class="dropdown-item iom-category-editcat iom-svg-icon">
                        <img src="assets/images/edit.svg" alt="" class="myw-icon myw-14" />
                        <span>Edit</span>
                      </a>
                      <a [ngClass]="{'disabled': categoryObj.TicketCount == 0 || (subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))}"
                         (click)="TriggerNewSubcategory($event, categoryObj.CateId)"
                         class="dropdown-item iom-category-new iom-svg-icon">
                        <img src="assets/images/add.svg" alt="" class="myw-icon myw-14" />
                        <span>New Sub Category</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="categoryObj.CategoryType != 'Kmeans' && IsKmeans"
                   class="iom-category-col iom-category-option novisibility mx-auto">
                <div (click)="LoadDataForRecategorize(categoryObj.CateId)"
                     class="dropdown dropright dropflat d-inline-block">
                  <a href="javascript:;" class="d-inline-block d-flex  ml-auto" role="button"
                     data-bs-toggle="modal" data-bs-target="#RecategorizeModel" aria-haspopup="true"
                     aria-expanded="false" title="More Options">
                    <img src="assets/images/three-dot.svg" alt="Re Categorize"
                         style="cursor: pointer;">
                    <span class="sr-only">Re Categorize</span>
                  </a>
                  <!-- <div class="dropdown-menu mb-3">
                      <div class="dropdown-body dropautomation">
                          <div class="form-group">
                              <label class="form-label">Edit Catagory</label>
                              <input type="text" class="form-control"
                                  placeholder="Fund Transfer Issues">
                          </div>
                          <div class="form-group mb-0 d-flex justify-content-center">
                              <button type="button" class="btn btn-secondary">
                                  <img src="images/category.svg" alt="Re Categorize">
                                  <span class="text-nowrap">Re Categorize</span>
                              </button>
                          </div>
                          <div class="form-group">
                              <label class="form-label">No of Cluster</label>
                              <input type="text" class="form-control" placeholder="Enter No">
                          </div>
                          <div class="form-group">
                              <label class="form-label">Exit Creteria</label>
                              <input type="text" class="form-control" placeholder="Enter creteria">
                          </div>
                          <div class="form-group mb-0 d-flex justify-content-center">
                              <button type="button" class="btn btn-secondary">
                                  <img src="images/category.svg" alt="Re Categorize">
                                  <span class="text-nowrap">Re Categorize</span>
                              </button>
                          </div>
                      </div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="iom-subcategory">
              <!-- split category -->
              <div class="iom-splitcategory d-none">
                <div class="row no-gutters">
                  <div class="col pb-4">
                    <div class="iom-subcategory-section">
                      <div class="form-group">
                        <label class="form-label">Category</label>
                        <input type="text" class="form-control"
                               [readonly]="categoryObj.CategoryType == 'Kmeans' || categoryObj.CategoryType == 'Standard'"
                               [(ngModel)]="CategoryObj.CategoryName"
                               placeholder="Enter Category" (keypress)="OnKeypressIncludeSpace($event)" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Keywords considered</label>
                        <div class="form-control control-border rounded imo-keys">
                          <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                            <div [ngClass]="{'imo-keys-list':true}"
                                 (click)="SelectKeyword($event, incKey, true, true)">
                              <a>{{incKey}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-label">Exclude Text With</label>
                        <div class="form-control control-border rounded imo-keys">
                          <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                            <div [ngClass]="{'imo-keys-list':true}"
                                 (click)="SelectKeyword($event, excKey, false, true)">
                              <a>{{excKey}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <h4 class="fs-14 mb-0">Dashboard</h4>
                        <label class="myw-flip">
                          <input type="checkbox"
                                 [(ngModel)]="CategoryObj.IsDashboardEnabled"
                                 [checked]="CategoryObj.IsDashboardEnabled"
                                 [value]="CategoryObj.IsDashboardEnabled" /><span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <div class="d-flex align-items-center justify-content-center h-100 iom-change">
                      <a style="cursor: pointer;" (click)="SwapKeyword($event)">
                        <span class="sr-only">Change</span>
                      </a>
                    </div>
                  </div>
                  <div class="col pb-4">
                    <div class="iom-subcategory-section">
                      <div class="form-group">
                        <label class="form-label">Category</label>
                        <input type="text" [(ngModel)]="SplitObj.CategoryName"
                               class="form-control" name="splitcatName"
                               [value]="SplitObj.CategoryName" placeholder="Enter Category Name" (keypress)="OnKeypressIncludeSpace($event)" />
                      </div>
                      <div class="form-group">
                        <label class="form-label">Keywords considered</label>
                        <div class="form-control control-border rounded imo-keys">
                          <div *ngFor="let incKey of SplitObj.IncludedKeywords;let i = index">
                            <div [ngClass]="{'imo-keys-list':true}"
                                 (click)="SelectKeyword($event, incKey, true, false)">
                              <a>{{incKey}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-label">Exclude Text With</label>
                        <div class="form-control control-border rounded imo-keys">
                          <div *ngFor="let excKey of SplitObj.ExcludedKeywords;let i = index">
                            <div [ngClass]="{'imo-keys-list':true}"
                                 (click)="SelectKeyword($event, excKey, false, false)">
                              <a>{{excKey}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center justify-content-between">
                        <h4 class="fs-14 mb-0">Dashboard</h4>
                        <label class="myw-flip">
                          <input type="checkbox"
                                 [(ngModel)]="SplitObj.IsDashboardEnabled"
                                 [checked]="SplitObj.IsDashboardEnabled"
                                 [value]="SplitObj.IsDashboardEnabled" /><span></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section text-center py-4">
                  <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                          (click)="SaveSplit(true, categoryObj.CategoryName)"
                          class="btn btn-primary px-5 iom-category-split">
                    Save
                  </button>
                  <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                          class="btn btn-primary px-5 iom-category-split disabled">
                    Save
                  </button>
                  <button type="button" (click)="Cancel($event, 'split', true)"
                          class="btn btn-secondary px-5 ml-4 iom-category-split">
                    Cancel
                  </button>
                </div>
              </div>
              <!-- edit category -->
              <div class="iom-editcategory py-3 d-none">
                <div class="iom-subcategory-section">
                  <h3 class="fs-16">
                    <img src="assets/images/back.png" alt="" class="myw-icon mr-2"
                         (click)="Cancel($event, 'edit', true)" style="cursor: pointer;" />Edit
                    Category
                  </h3>
                  <div class="row mt-4">
                    <div class="col-4">
                      <div class="form-group">
                        <label class="form-label">Category Name</label>
                        <input type="text" class="form-control"
                               [value]="CategoryObj.CategoryName"
                               [readonly]="categoryObj.CategoryType == 'Kmeans' || categoryObj.CategoryType == 'Standard'"
                               [(ngModel)]="CategoryObj.CategoryName" name="editcatName"
                               placeholder="Enter Category" (keypress)="OnKeypressIncludeSpace($event)" />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType != 'Kmeans'">
                  <h4 class="fs-14">Keywords considered</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Keywords considered</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, incKey, true, i)">
                            <a>
                              {{incKey}}<span class="close" *ngIf="!categoryNameEditOnly"
                                              (click)="RemoveKeyword(incKey, true)">×</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Should include All of the following:</h4>
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)"
                               [(ngModel)]="CategoryObj.includeContainsText_1"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)"
                               [(ngModel)]="CategoryObj.includeContainsText_2"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_3"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_4"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                      <h4 class="fs-14">But should not include any following:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                             
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_1"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_2"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_3"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_4"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex" *ngIf="!categoryNameEditOnly">
                    <!-- <button (click)="AddNew($event, true)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, true)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event, true)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.includedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType == 'Kmeans'">
                  <h4 class="fs-14">Keywords considered</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Keywords considered</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, incKey, true, i)">
                            <a>
                              {{incKey}}<span class="close"
                                              (click)="RemoveKeyword(incKey, true)">×</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Should include All of the following:</h4>
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                      <h4 class="fs-14">But should not include any following:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                             
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex">
                    <!-- <button (click)="AddNew($event, true)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, true)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event,true)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.includedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType != 'Kmeans'">
                  <h4 class="fs-14">Exclude Text With</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Exclude Text With</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, excKey, false, i)">
                            <a>
                              {{excKey}}<span class="close" *ngIf="!categoryNameEditOnly"
                                              (click)="RemoveKeyword(excKey, false)">×</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Exclusion Criteria:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_1"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_2"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)"
                               [(ngModel)]="CategoryObj.excludeText_3"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_4"
                               [readonly]="categoryNameEditOnly"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex" *ngIf="!categoryNameEditOnly">
                    <!-- <button (click)="AddNew($event, false)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, false)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event,false)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.excludedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType == 'Kmeans'">
                  <h4 class="fs-14">Exclude Text With</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Exclude Text With</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, excKey, false, i)">
                            <a>
                              {{excKey}}<span class="close"
                                              (click)="RemoveKeyword(excKey, false)">×</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Exclusion Criteria:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex">
                    <!-- <button (click)="AddNew($event, false)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, false)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event,false)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.excludedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType != 'Kmeans'">
                  <div class="d-flex align-items-center justify-content-between">
                    <h4 class="fs-14 mb-0">Dashboard</h4>
                    <label class="myw-flip">
                      <input type="checkbox"
                             [(ngModel)]="CategoryObj.IsDashboardEnabled"
                             [value]="CategoryObj.IsDashboardEnabled"
                             [checked]="CategoryObj.IsDashboardEnabled"
                             [disabled]="categoryNameEditOnly" /><span></span>
                    </label>
                  </div>
                </div>
                <div class="iom-subcategory-section" *ngIf="categoryObj.CategoryType == 'Kmeans'">
                  <div class="d-flex align-items-center justify-content-between">
                    <h4 class="fs-14 mb-0">Dashboard</h4>
                    <label class="myw-flip">
                      <input type="checkbox"
                             [(ngModel)]="CategoryObj.IsDashboardEnabled"
                             [value]="CategoryObj.IsDashboardEnabled"
                             [checked]="CategoryObj.IsDashboardEnabled" /><span></span>
                    </label>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section text-center py-3">
                  <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                          class="btn btn-primary px-5 iom-category-editcat"
                          (click)="SaveEdit(true, categoryObj.CategoryName, categoryObj.CategoryType)">
                    Save
                  </button>
                  <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                          class="btn btn-primary px-5 iom-category-editcat disabled">
                    Save
                  </button>
                  <button type="button" (click)="Cancel($event, 'edit', true)"
                          class="btn btn-secondary px-5 ml-4 iom-category-editcat">
                    Cancel
                  </button>
                </div>
              </div>
              <!-- new subcategory -->
              <div class="iom-newsubcategory py-3 d-none">
                <div class="iom-subcategory-section">
                  <h3 class="fs-16">
                    <img src="assets/images/back.png" alt="" class="myw-icon mr-2"
                         (click)="Cancel($event, 'new', false)" style="cursor: pointer;" />New Sub
                    Category
                  </h3>
                  <div class="row mt-4">
                    <div class="col-4">
                      <div class="form-group">
                        <label class="form-label">Sub Category Name</label>
                        <input type="text" class="form-control"
                               [(ngModel)]="CategoryObj.CategoryName"
                               placeholder="Enter Subcategory Name" (keypress)="OnKeypressIncludeSpace($event)" />
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section">
                  <h4 class="fs-14">Keywords considered</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Keywords considered</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, incKey, true, i)">
                            <a>
                              {{incKey}}
                              <span class="remove-tag" style="font-weight: 500;color:red;" (click)="RemoveKeyword(incKey, true)">  X</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Should include All of the following:</h4>
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressShouldInclude($event)" [(ngModel)]="CategoryObj.includeContainsText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                      <h4 class="fs-14">But should not include any following:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                            
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               [disabled]="!this.include_enable"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.includeNotContainsText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex">
                    <!-- <button (click)="AddNew($event, true)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, true)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event,true)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.includedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section">
                  <h4 class="fs-14">Exclude Text With</h4>
                  <div class="row">
                    <div class="col-3">
                      <label class="sr-only">Exclude Text With</label>
                      <div class="form-control control-border rounded imo-keys">
                        <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                          <div [ngClass]="{'imo-keys-list':true}"
                               (click)="LoadKeyword($event, excKey, false, i)">
                            <a>
                              {{excKey}}
                              <span class="remove-tag" style="font-weight: 500;color:red;" (click)="RemoveKeyword(excKey, false)">  X</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col align-self-center">
                      <h4 class="fs-14">Exclusion Criteria:</h4>
                      <div class="d-flex align-items-center justify-content-between">
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)" [(ngModel)]="CategoryObj.excludeText_1"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)"
                               [(ngModel)]="CategoryObj.excludeText_2"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)"
                               [(ngModel)]="CategoryObj.excludeText_3"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                        <strong class="text-secondary mx-4">AND</strong>
                        <input type="text"
                               onDrag="return false" onDrop="return false"
                               (keypress)="OnKeypressIncludeExclude($event)"
                               [(ngModel)]="CategoryObj.excludeText_4"
                               class="form-control control-border rounded"
                               placeholder="Contains" />
                      </div>
                    </div>
                  </div>
                  <div class="pt-3 d-flex">
                    <!-- <button (click)="AddNew($event, false)" type="button" class="btn btn-light">
                        <img src="assets/images/update.svg" alt="Update" class="btn-img">
                        <span>Add New</span>
                    </button> -->
                    <div class="text-right d-flex justify-content-end ml-auto">
                      <button (click)="ResetKeyword($event, false)" type="button"
                              class="btn btn-secondary">
                        <span>Reset</span>
                      </button>
                      <button (click)="AddUpdateKeyword($event,false)" type="button"
                              class="btn btn-primary ml-4">
                        <span>{{CategoryObj.excludedBtnName}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section">
                  <div class="d-flex align-items-center justify-content-between">
                    <h4 class="fs-14 mb-0">Dashboard</h4>
                    <label class="myw-flip">
                      <input type="checkbox"
                             [(ngModel)]="CategoryObj.IsDashboardEnabled"
                             [checked]="CategoryObj.IsDashboardEnabled"
                             [value]="CategoryObj.IsDashboardEnabled" /><span></span>
                    </label>
                  </div>
                </div>
                <hr />
                <div class="iom-subcategory-section text-center py-3">
                  <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                          (click)="SaveNew(false)"
                          class="btn btn-primary px-5 iom-category-editcat">
                    Save
                  </button>
                  <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                          class="btn btn-primary px-5 iom-category-editcat disabled">
                    Save
                  </button>
                  <button type="button" (click)="Cancel($event, 'new', false)"
                          class="btn btn-secondary px-5 ml-4 iom-category-editcat">
                    Cancel
                  </button>
                </div>
              </div>
              <!-- sub category -->
              <div class="iom-category-row" style="text-align: center;"
                   *ngIf="(IsEmpty(OpportunityBy) && !IsEmpty(categoryObj.SubCatType) && categoryObj.SubCatType != 'TopicModelling')">
                "{{categoryObj.SubCatType}}" is found as a significant contributor for this Category
              </div>              
              <div>
              <div class="parentdivsubcategory"
                   [ngClass]="{'d-none':(IsEmpty(OpportunityBy) && !IsEmpty(categoryObj.SubCatType) && categoryObj.SubCatType != 'TopicModelling')}"
                   *ngFor="let subcatObj of categoryObj.SubCategoryDetails">
                <div *ngIf="!IsEmpty(subcatObj.IsSubCategory) && subcatObj.IsSubCategory != 3">
                  <div class="iom-category-row iom-subcategory-view"
                       id="Subcategory_{{categoryObj.CateId}}_{{subcatObj.SubCategoryID}}">
                    <div class="iom-category-col iom-category-cb invisible">
                      <label class="myw-checkbox myw-inline" *ngIf="subcatObj.IsSubCategory != 0">
                        <input (change)="SelectobjectForMerge($event, false, categoryObj.CateId, subcatObj.SubCategoryID, false)"
                               type="checkbox" name="category-option" />
                        <span></span>
                      </label>
                    </div>
                    <div class="iom-category-col iom-category-toggle">&nbsp;</div>
                    <div class="iom-category-col iom-category-category"
                         title="{{categoryObj.CategoryType}}">
                      {{subcatObj.SubCategoryName}}
                    </div>
                    <div class="iom-category-col iom-category-ticket">
                      <div class="iom-ticket-info">
                        <span>{{subcatObj.Sub_Percentage}}%</span>
                        <span>{{formatNumber(subcatObj.Sub_TicketCount)}}<br />Tickets</span>
                      </div>
                    </div>
                    <div class="iom-category-col iom-category-key" style="width:100%; height: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                         ellipsis title="{{subcatObj.Sub_IncludedKeyWords}}">
                      {{subcatObj.Sub_IncludedKeyWords}}
                    </div>
                    <div class="iom-category-col iom-category-exclude"
                         style="width:100%; height: 75px;" ellipsis
                         title="{{subcatObj.Sub_ExcludedKeyWords}}">
                      {{subcatObj.Sub_ExcludedKeyWords}}
                    </div>
                    <div class="iom-category-col iom-category-tat">
                      <span style="padding-left: 18px;">{{subcatObj.TATSubCat}}</span>
                    </div>
                    <div class="iom-category-col iom-category-dashboard">&nbsp;</div>
                    <div *ngIf="subcatObj.IsSubCategory != 0"
                         class="iom-category-col iom-category-option novisibility mx-auto">
                      <div class="dropdown dropright dropflat d-inline-block">
                        <a [ngClass]="{'d-inline-block': isSubcatOptionsEnabled}"
                           class="d-inline-block d-flex ml-auto" (click)="EnableDisableMerge(categoryObj.CateId)"
                           [ngStyle]="{'visibility': (isSubcatOptionsEnabled ? 'visible' : 'hidden')}"
                           role="button" data-bs-toggle="dropdown" data-bs-display="static"
                           aria-haspopup="true" aria-expanded="false" title="More Options">
                          <img src="assets/images/three-dot.svg" alt="More Options"
                               style="cursor: pointer;" />
                          <span class="sr-only">More Options</span>
                        </a>
                        <div class="iom-dropdwn dropdown-menu">
                          <div class="dropdown-body">
                            <a [ngClass]="{'disabled':(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans') || this.mergedisable)}"
                               (click)="TriggerMerge($event, false, categoryObj.CateId, subcatObj.SubCategoryID)"
                               class="dropdown-item iom-subcategory-merge iom-svg-icon" *ngIf="!mergedisable">
                              <img src="assets/images/merge.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Merge</span>
                            </a>
                            <a [ngClass]="{'disabled':(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))}"
                               (click)="TriggerSplit($event, false, categoryObj.CateId, subcatObj.SubCategoryID)"
                               class="dropdown-item iom-subcategory-split iom-svg-icon">
                              <img src="assets/images/split.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Split</span>
                            </a>
                            <a [ngClass]="{'disabled': selectedLangAll}"
                            (click)="TriggerEdit($event, false, categoryObj.CateId, subcatObj.SubCategoryID)"
                               class="dropdown-item">
                              <img src="assets/images/edit.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Edit</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- split subcategory -->
                  <div class="iom-splitsubcategory iom-subcategory d-none">
                    <div class="row no-gutters">
                      <div class="col pb-4">
                        <div class="iom-subcategory-section">
                          <div class="form-group">
                            <label class="form-label">Subcategory</label>
                            <input type="text" class="form-control"
                                   [(ngModel)]="CategoryObj.CategoryName"
                                   placeholder="Enter Subcategory Name" (keypress)="OnKeypressIncludeSpace($event)" />
                          </div>
                          <div class="form-group">
                            <label class="form-label">Keywords considered</label>
                            <div class="form-control control-border rounded imo-keys">
                              <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                                <div [ngClass]="{'imo-keys-list':true}"
                                     (click)="SelectKeyword($event, incKey, true, true)">
                                  <a>{{incKey}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Exclude Text With</label>
                            <div class="form-control control-border rounded imo-keys">
                              <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                                <div [ngClass]="{'imo-keys-list':true}"
                                     (click)="SelectKeyword($event, excKey, false, true)">
                                  <a>{{excKey}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-auto">
                        <div class="d-flex align-items-center justify-content-center h-100 iom-change">
                          <a style="cursor: pointer;" (click)="SwapKeyword($event)">
                            <span class="sr-only">Change</span>
                          </a>
                        </div>
                      </div>
                      <div class="col pb-4">
                        <div class="iom-subcategory-section">
                          <div class="form-group">
                            <label class="form-label">Subcategory</label>
                            <input [(ngModel)]="SplitObj.CategoryName" type="text"
                                   class="form-control" name="splitcatName"
                                   [value]="SplitObj.CategoryName"
                                   placeholder="Enter Subcategory Name" (keypress)="OnKeypressIncludeSpace($event)" />
                          </div>
                          <div class="form-group">
                            <label class="form-label">Keywords considered</label>
                            <div class="form-control control-border rounded imo-keys">
                              <div *ngFor="let incKey of SplitObj.IncludedKeywords;let i = index">
                                <div [ngClass]="{'imo-keys-list':true}"
                                     (click)="SelectKeyword($event, incKey, true, false)">
                                  <a>{{incKey}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="form-label">Exclude Text With</label>
                            <div class="form-control control-border rounded imo-keys">
                              <div *ngFor="let excKey of SplitObj.ExcludedKeywords;let i = index">
                                <div [ngClass]="{'imo-keys-list':true}"
                                     (click)="SelectKeyword($event, excKey, false, false)">
                                  <a>{{excKey}}</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="iom-subcategory-section text-center py-4">
                      <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                              (click)="SaveSplit(false, subcatObj.SubCategoryName)"
                              class="btn btn-primary px-5 iom-category-split">
                        Save
                      </button>
                      <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                              class="btn btn-primary px-5 iom-category-split disabled">
                        Save
                      </button>
                      <button type="button" (click)="Cancel($event, 'split', false)"
                              class="btn btn-secondary px-5 ml-4 iom-category-split">
                        Cancel
                      </button>
                    </div>
                  </div>
                  <!-- edit subcategory -->
                  <div class="iom-editsubcategory py-3 d-none">
                    <div class="iom-subcategory-section">
                      <h3 class="fs-16">
                        <img src="assets/images/back.png" alt=""
                             class="myw-icon mr-2" (click)="Cancel($event, 'edit', false)"
                             style="cursor: pointer;" />Edit
                        Subcategory
                      </h3>
                      <div class="row mt-4">
                        <div class="col-4">
                          <div class="form-group">
                            <label class="form-label">Subcategory Name</label>
                            <input type="text" class="form-control"
                                   [(ngModel)]="CategoryObj.CategoryName"
                                   placeholder="Enter Subcategory Name" (keypress)="OnKeypressIncludeSpace($event)" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="iom-subcategory-section">
                      <h4 class="fs-14">Keywords considered</h4>
                      <div class="row">
                        <div class="col-3">
                          <label class="sr-only">Keywords considered</label>
                          <div class="form-control control-border rounded imo-keys">
                            <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                              <div [ngClass]="{'imo-keys-list':true}"
                                   (click)="LoadKeyword($event, incKey, true, i)">
                                <a>
                                  {{incKey}}<span class="close"
                                                  *ngIf="!(subCategoryNameEditOnly  || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                                  (click)="RemoveKeyword(incKey, true)">×</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col align-self-center">
                          <h4 class="fs-14">Should include All of the following:</h4>
                          <div class="d-flex align-items-center justify-content-between mb-3">
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressShouldInclude($event)"
                                   [(ngModel)]="CategoryObj.includeContainsText_1"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressShouldInclude($event)"
                                   [(ngModel)]="CategoryObj.includeContainsText_2"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressShouldInclude($event)"
                                   [(ngModel)]="CategoryObj.includeContainsText_3"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressShouldInclude($event)"
                                   [(ngModel)]="CategoryObj.includeContainsText_4"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                          </div>
                          <h4 class="fs-14">But should not include any following:</h4>
                          <div class="d-flex align-items-center justify-content-between">
                            <input type="text"
                               
                                   [(ngModel)]="CategoryObj.includeNotContainsText_1"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text" [disabled]="!this.include_enable"
                                   [(ngModel)]="CategoryObj.includeNotContainsText_2"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text" [disabled]="!this.include_enable"
                                   [(ngModel)]="CategoryObj.includeNotContainsText_3"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text" [disabled]="!this.include_enable"
                                   [(ngModel)]="CategoryObj.includeNotContainsText_4"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                          </div>
                        </div>
                      </div>
                      <div class="pt-3 d-flex"
                           *ngIf="!(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))">
                        <!-- <button (click)="AddNew($event, true)" type="button"
                            class="btn btn-light">
                            <img src="assets/images/update.svg" alt="Update" class="btn-img">
                            <span>Add New</span>
                        </button> -->
                        <div class="text-right d-flex justify-content-end ml-auto">
                          <button (click)="ResetKeyword($event, true)" type="button"
                                  class="btn btn-secondary">
                            <span>Reset</span>
                          </button>
                          <button (click)="AddUpdateKeyword($event,true)" type="button"
                                  class="btn btn-primary ml-4">
                            <span>{{CategoryObj.includedBtnName}}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="iom-subcategory-section">
                      <h4 class="fs-14">Exclude Text With</h4>
                      <div class="row">
                        <div class="col-3">
                          <label class="sr-only">Exclude Text With</label>
                          <div class="form-control control-border rounded imo-keys">
                            <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                              <div [ngClass]="{'imo-keys-list':true}"
                                   (click)="LoadKeyword($event, excKey, false, i)">
                                <a>
                                  {{excKey}}<span class="close"
                                                  *ngIf="!(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                                  (click)="RemoveKeyword(excKey, false)">×</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col align-self-center">
                          <h4 class="fs-14">Exclusion Criteria:</h4>
                          <div class="d-flex align-items-center justify-content-between">
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressIncludeExclude($event)"
                                   [(ngModel)]="CategoryObj.excludeText_1"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressIncludeExclude($event)"
                                   [(ngModel)]="CategoryObj.excludeText_2"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressIncludeExclude($event)"
                                   [(ngModel)]="CategoryObj.excludeText_3"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                            <strong class="text-secondary mx-4">AND</strong>
                            <input type="text"
                                   onDrag="return false" onDrop="return false"
                                   (keypress)="OnKeypressIncludeExclude($event)"
                                   [(ngModel)]="CategoryObj.excludeText_4"
                                   [readonly]="(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))"
                                   class="form-control control-border rounded"
                                   placeholder="Contains" />
                          </div>
                        </div>
                      </div>
                      <div class="pt-3 d-flex"
                           *ngIf="!(subCategoryNameEditOnly || (IsKmeans && categoryObj.CategoryType != 'Kmeans'))">
                        <!-- <button (click)="AddNew($event, false)" type="button"
                            class="btn btn-light">
                            <img src="assets/images/update.svg" alt="Update" class="btn-img">
                            <span>Add New</span>
                        </button> -->
                        <div class="text-right d-flex justify-content-end ml-auto">
                          <button (click)="ResetKeyword($event, false)" type="button"
                                  class="btn btn-secondary">
                            <span>Reset</span>
                          </button>
                          <button (click)="AddUpdateKeyword($event,false)" type="button"
                                  class="btn btn-primary ml-4">
                            <span>{{CategoryObj.excludedBtnName}}</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="iom-subcategory-section text-center py-3">
                      <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                              (click)="SaveEdit(false, subcatObj.SubCategoryName, categoryObj.CategoryType)"
                              class="btn btn-primary px-5 iom-category-editcat">
                        Save
                      </button>
                      <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                              class="btn btn-primary px-5 iom-category-editcat disabled">
                        Save
                      </button>
                      <button type="button" (click)="Cancel($event, 'edit', false)"
                              class="btn btn-secondary px-5 ml-4 iom-category-editcat">
                        Cancel
                      </button>
                    </div>
                  </div>
                  <!-- merge subcategory -->
                  <div class="iom-category-row mergesubcategorydata d-none">
                    <div style="visibility: hidden !important;"
                         class="iom-category-col iom-category-cb invisible">
                      <label class="myw-checkbox myw-inline">
                        <input type="checkbox" name="category-option" />
                        <span></span>
                      </label>
                    </div>
                    <div class="iom-category-col iom-category-toggle">&nbsp;</div>
                    <div class="iom-category-col iom-category-category">
                      <input type="text"
                             [(ngModel)]="MergeObj.CategoryName"
                             style="font-weight: 500;color:black;" id="subCatNameTextBox"
                             class="form-control" />
                    </div>
                    <div class="iom-category-col iom-category-ticket">
                      <div class="iom-ticket-info">
                        <span>{{MergeObj.Percentage}}%</span>
                        <span>{{MergeObj.TicketCount}}<br />Tickets</span>
                      </div>
                    </div>
                    <div class="iom-category-col iom-category-key" style="width:100%; height: 75px;white-space: nowrap;
                                    overflow: hidden;text-overflow: ellipsis;"
                         title="{{MergeObj.strIncludedKeywords}}">
                      {{MergeObj.strIncludedKeywords}}
                    </div>
                    <div class="iom-category-col iom-category-exclude" style="width:100%; height: 75px;white-space: nowrap;
                                    overflow: hidden;text-overflow: ellipsis;"
                         title="{{MergeObj.strExcludedKeywords}}">
                      {{MergeObj.strExcludedKeywords}}
                    </div>
                    <div class="iom-category-col iom-category-tat">
                      <span style="padding-left: 18px;">{{MergeObj.TAT}}</span>
                    </div>
                    <div class="iom-category-col iom-category-dashboard">&nbsp;</div>
                    <div style="visibility: hidden !important;"
                         class="iom-category-col iom-category-option novisibility mx-auto">
                      <div class="dropdown dropright dropflat d-inline-block">
                        <a role="button" data-bs-toggle="dropdown" data-bs-display="static"
                           aria-haspopup="true" aria-expanded="false" title="More Options">
                          <img src="assets/images/three-dot.svg" alt="More Options"
                               style="cursor: pointer;" />
                          <span class="sr-only">More Options</span>
                        </a>
                        <div class="iom-dropdwn dropdown-menu">
                          <div class="dropdown-body">
                            <a class="dropdown-item iom-subcategory-merge iom-svg-icon">
                              <img src="assets/images/merge.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Merge</span>
                            </a>
                            <a class="dropdown-item iom-subcategory-split iom-svg-icon">
                              <img src="assets/images/split.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Split</span>
                            </a>
                            <a class="dropdown-item">
                              <img src="assets/images/edit.svg" alt=""
                                   class="myw-icon myw-14" />
                              <span>Edit</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="iom-mergesubcategory my-4 text-center d-none">
                    <button type="button" (click)="MergeData($event, false)"
                            class="btn btn-primary px-5 iom-subcategory-merge">
                      {{MergeSubcatBtnText}}
                    </button>
                    <button type="button" (click)="Cancel($event, 'merge', false)"
                            class="btn btn-secondary px-5 ml-4 iom-subcategory-merge">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <!-- merge category -->
          <div class="iom-category mergecategorydata iom-category-row iom-category-head d-none">
            <div style="visibility: hidden !important;" class="iom-category-col iom-category-cb invisible">
              <label class="myw-checkbox myw-inline">
                <input type="checkbox" name="category-option" />
                <span></span>
              </label>
            </div>
            <div class="iom-category-col iom-category-toggle d-none">
              <a title="Expand/Collapse"><span class="sr-only">Expand/Collapse</span></a>
            </div>
            <div class="iom-category-col iom-category-category">
              <input type="text"
                     [(ngModel)]="MergeObj.CategoryName" style="font-weight: 500;color:black;"
                     id="catNameTextBox" class="form-control" />
            </div>
            <div class="iom-category-col iom-category-ticket">
              <div class="iom-ticket-info">
                <span>{{MergeObj.Percentage}}%</span>
                <span>{{MergeObj.TicketCount}}<br />Tickets</span>
              </div>
            </div>
            <div class="iom-category-col iom-category-key" style="width:100%; height: 75px;white-space: nowrap;
                        overflow: hidden;text-overflow: ellipsis;" title="{{MergeObj.strIncludedKeywords}}">
              {{MergeObj.strIncludedKeywords}}
            </div>
            <div class="iom-category-col iom-category-exclude" style="width:100%; height: 75px;white-space: nowrap;
                        overflow: hidden;text-overflow: ellipsis;" title="{{MergeObj.strExcludedKeywords}}">
              {{MergeObj.strExcludedKeywords}}
            </div>
            <div class="iom-category-col iom-category-tat">
              <span style="padding-left: 18px;">{{MergeObj.TAT}}</span>
            </div>
            <div class="iom-category-col iom-category-dashboard">
              <label class="myw-flip">
                <input type="checkbox" [ngModel]="MergeObj.IsDashboardEnabled"
                       [checked]="MergeObj.IsDashboardEnabled"
                       [value]="MergeObj.IsDashboardEnabled" /><span></span>
              </label>
            </div>
            <div style="visibility: hidden !important;"
                 class="iom-category-col iom-category-option novisibility mx-auto">
              <div class="dropdown dropright dropflat d-inline-block">
                <a role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-haspopup="true"
                   aria-expanded="false" title="More Options">
                  <img src="assets/images/three-dot.svg" alt="More Options"
                       style="cursor: pointer;" />
                  <span class="sr-only">More Options</span>
                </a>
                <div class="iom-dropdwn dropdown-menu">
                  <div class="dropdown-body">
                    <a class="dropdown-item iom-category-merge iom-svg-icon">
                      <img src="assets/images/merge.svg" alt="" class="myw-icon myw-14" />
                      <span>Merge</span>
                    </a>
                    <a class="dropdown-item iom-category-split iom-svg-icon">
                      <img src="assets/images/split.svg" alt="" class="myw-icon myw-14" />
                      <span>Split</span>
                    </a>
                    <a class="dropdown-item iom-category-editcat">
                      <img src="assets/images/edit.svg" alt="" class="myw-icon myw-14" />
                      <span>Edit</span>
                    </a>
                    <a class="dropdown-item iom-category-new">
                      <img src="assets/images/add.svg" alt="" class="myw-icon myw-14" />
                      <span>New Sub Category</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="iom-mergecategory my-4 text-center d-none">
            <button type="button" *ngIf="this.iomservice.readonlyDD == false"
                    (click)="MergeData($event, true)"
                    class="btn btn-primary px-5 iom-category-merge">
              {{MergeCatBtnText}}
            </button>
            <button type="button" *ngIf="this.iomservice.readonlyDD == true"
                    class="btn btn-primary px-5 iom-category-merge disabled">
              {{MergeCatBtnText}}
            </button>
            <button type="button" (click)="Cancel($event, 'merge', true)"
                    class="btn btn-secondary px-5 ml-4 iom-category-merge">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isLoadNewCategory" class="iom-section-category-inner"
         [ngClass]="{active: (isLoadNewCategory && !IsKmeans)}">
      <div class="iom-newsubcategory pt-3">
        <div class="iom-subcategory-section">
          <h3 class="fs-16">
            <img src="assets/images/back.png" alt="" class="myw-icon mr-2" (click)="loadCategoryTable()"
                 style="cursor: pointer;" />
            Create New Category
          </h3>
          <div class="row mt-4">
            <div class="col-4">
              <div class="form-group">
                <label class="form-label">Category</label>
                <input type="text" class="form-control" [(ngModel)]="CategoryObj.CategoryName"
                       placeholder="Enter Category Name"
                       (keypress)="OnKeypressIncludeSpace($event)" />
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="iom-subcategory-section">
          <h4 class="fs-14">Keywords considered</h4>
          <div class="row">
            <div class="col-3">
              <label class="sr-only">Keywords considered</label>
              <div class="form-control control-border rounded imo-keys">
                <div *ngFor="let incKey of CategoryObj.IncludedKeywords;let i = index">
                  <div [ngClass]="{'imo-keys-list':true}"
                       (click)="LoadKeyword($event, incKey, true, i)">
                    <a>
                      {{incKey}}
                      <span class="remove-tag" style="font-weight: 500;color:red;" (click)="RemoveKeyword(incKey, true)">  X</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col align-self-center">
              <h4 class="fs-14">Should include All of the following:</h4>
              <div class="d-flex align-items-center justify-content-between mb-3">
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressShouldInclude($event)"
                       [(ngModel)]="CategoryObj.includeContainsText_1"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressShouldInclude($event)"
                       [(ngModel)]="CategoryObj.includeContainsText_2"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressShouldInclude($event)"
                       [(ngModel)]="CategoryObj.includeContainsText_3"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressShouldInclude($event)"
                       [(ngModel)]="CategoryObj.includeContainsText_4"
                       class="form-control control-border rounded" placeholder="Contains" />
              </div>
              <h4 class="fs-14">But should not include any following:</h4>
              <div class="d-flex align-items-center justify-content-between">
                <input type="text" onDrag="return false"
                       onDrop="return false" 
          
                       (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.includeNotContainsText_1"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false"
                       [disabled]="!this.include_enable"
                      (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.includeNotContainsText_2"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false"
                       [disabled]="!this.include_enable"
                      (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.includeNotContainsText_3"
                       class="form-control control-border rounded" placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" 
                       [disabled]="!this.include_enable"
                       (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.includeNotContainsText_4"
                       class="form-control control-border rounded" placeholder="Contains" />
              </div>
            </div>
          </div>
          <div class="pt-3 d-flex">
            <!-- <button (click)="AddNew($event, true)" type="button" class="btn btn-light">
                <img src="assets/images/update.svg" alt="Update" class="btn-img">
                <span>Add New</span>
            </button> -->
            <div class="text-right d-flex justify-content-end ml-auto">
              <button (click)="ResetKeyword($event, true)" type="button" class="btn btn-secondary">
                <span>Reset</span>
              </button>
              <button (click)="AddUpdateKeyword($event,true)" type="button" class="btn btn-primary ml-4">
                <span>{{CategoryObj.includedBtnName}}</span>
              </button>
            </div>
          </div>
        </div>
        <hr />
        <div class="iom-subcategory-section">
          <h4 class="fs-14">Exclude Text With</h4>
          <div class="row">
            <div class="col-3">
              <label class="sr-only">Exclude Text With</label>
              <div class="form-control control-border rounded imo-keys">
                <div *ngFor="let excKey of CategoryObj.ExcludedKeywords;let i = index">
                  <div [ngClass]="{'imo-keys-list':true}"
                       (click)="LoadKeyword($event, excKey, false, i)">
                    <a>
                      {{excKey}}
                      <span class="remove-tag" style="font-weight: 500;color:red;" (click)="RemoveKeyword(excKey, false)">  X</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col align-self-center">
              <h4 class="fs-14">Exclusion Criteria:</h4>
              <div class="d-flex align-items-center justify-content-between">
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.excludeText_1" class="form-control control-border rounded"
                       placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.excludeText_2" class="form-control control-border rounded"
                       placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.excludeText_3" class="form-control control-border rounded"
                       placeholder="Contains" />
                <strong class="text-secondary mx-4">AND</strong>
                <input type="text" onDrag="return false"
                       onDrop="return false" (keypress)="OnKeypressIncludeExclude($event)"
                       [(ngModel)]="CategoryObj.excludeText_4" class="form-control control-border rounded"
                       placeholder="Contains" />
              </div>
            </div>
          </div>
          <div class="pt-3 d-flex">
            <!-- <button (click)="AddNew($event, false)" type="button" class="btn btn-light">
                <img src="assets/images/update.svg" alt="Update" class="btn-img">
                <span>Add New</span>
            </button> -->
            <div class="text-right d-flex justify-content-end ml-auto">
              <button (click)="ResetKeyword($event, false)" type="button" class="btn btn-secondary">
                <span>Reset</span>
              </button>
              <button (click)="AddUpdateKeyword($event,false)" type="button" class="btn btn-primary ml-4">
                <span>{{CategoryObj.excludedBtnName}}</span>
              </button>
            </div>
          </div>
        </div>
        <hr />
        <div class="iom-subcategory-section">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="fs-14 mb-0">Dashboard</h4>
            <label class="myw-flip">
              <input type="checkbox" [(ngModel)]="CategoryObj.IsDashboardEnabled"
                     name="toggle" [checked]="CategoryObj.IsDashboardEnabled"
                     [value]="CategoryObj.IsDashboardEnabled" /><span></span>
            </label>
          </div>
        </div>
        <hr />
        <div class="iom-subcategory-section text-center py-3">
          <a *ngIf="this.iomservice.readonlyDD == false" (click)="SaveNew(true)"
             class="btn btn-primary px-5">Save</a>
          <a *ngIf="this.iomservice.readonlyDD == true" class="btn btn-primary px-5 disabled">Save</a>
          <a (click)="loadCategoryTable()" class="btn btn-secondary px-5 ml-4">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal" id="ignoreModal" tabindex="-1" role="dialog" aria-labelledby="ignoreKeywords" aria-hidden="true"
    data-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="ignoreKeywords">Add/Delete Ignore Keywords</h5>
                <button type="button" class="close ignoreModelClose" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row myw-grid">
                    <div class="col">
                        <div [formGroup]="form1">
                            <label class="sr-only form-label">Ignore Keywords</label>
                            <div class="editor-tag">
                                <input #tagInput type="text"
                                    onDrag="return false" onDrop="return false" [readonly]="disableStopKeywords"
                                    (change)="keywordsAdd($event)" formControlName="tag"
                                    class="form-control control-border rounded"
                                    placeholder="Type in your ignore Keywords..." />
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <button type="button" [disabled]="disableStopKeywords" class="btn btn-primary px-4">Add</button>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-end mt-5 mb-2">
                    <label class="myw-checkbox myw-inline">
                        <input type="checkbox" (change)="SelectAllKeywords()" [(ngModel)]="SelectAllStatus"
                            [value]="SelectAllStatus" [disabled]="disableStopKeywords || disableSelectAll"
                            name="category-option" />
                        <span>Select All</span>
                    </label>
                    <button type="button" class="btn ml-2" [disabled]="disableStopKeywords || disableDelete"
                        (click)="DeleteAllKeywords()">
                        <img src="assets/images/delete-alt.svg" alt="Delete" />
                        <span>Delete</span>
                    </button>
                </div>
                <div *ngIf="enableBox" class="d-flex flex-wrap align-items-start border rounded pt-2 pb-3 px-3">
                    <span class="tag-item iom-selected-item" aria-label="Remove" *ngFor="let tag of tags"
                        name="userAccess">
                        {{tag}}
                        <span class="remove-tag" *ngIf="!disableStopKeywords" (click)="removeTag(tag)"
                            style="cursor: pointer;">×</span>
                    </span>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" [disabled]="disableStopKeywords" (click)="SaveIgnoreKeywords()"
                    class="btn btn-primary">Save</button>
            </div>
        </div>
    </div>
</div> -->
<div class="modal" id="ignoreModal" tabindex="-1" role="dialog" aria-labelledby="ignoreKeywords" aria-hidden="true"
     data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content iom-modewhite">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="ignoreKeywords">Add/Delete Ignore Keywords</h5>
      </div>
      <div class="modal-body  pt-0">
        <div class="fs-14 pb-3 text-grayclr">Edit Recommendation</div>
        <div class="row myw-grid">
          <div class="col">
            <div [formGroup]="form1">
              <label class="sr-only form-label">Ignore Keywords</label>
              <div class="editor-tag">
                <input #tagInput type="text" class="form-control mdl-frm-ctl control-border rounded"
                       onDrag="return false"
                       onDrop="return false" formControlName="tag"
                       placeholder="Type in your ignore Keywords..."
                       (keypress)="OnKeypressIncludeExcludeIgnoreKeyword($event)" />
              </div>
            </div>
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-secondary" (click)="keywordsAdd($event)"
                    [disabled]="disableStopKeywords">
              Add
            </button>
          </div>
        </div>

        <div *ngIf="enableBox" class="d-flex flex-wrap mdl-frm-ctl align-items-center rounded mt-4">
          <div class="row w-100">
            <div class="col">
              <!-- <a  *ngFor="let tag of tags"
               name="userAccess" class="iom-mdlselected-item mt-3 tag-item" aria-label="Remove">
                  <span class="mr-2">Raj; Unable</span> -->
              <span class="tag-item iom-mdlselected-item mt-3" aria-label="Remove"
                    *ngFor="let tag of tags" name="userAccess">
                {{tag}}
                <span class="remove-tag" *ngIf="!disableStopKeywords" (click)="removeTag(tag)"
                      style="cursor: pointer;">×</span>
              </span>
            </div>
            <div class="col-auto pr-0">
              <div class="d-flex iom-lft-bdr flex-column justify-content-end">
                <label class="myw-checkbox myw-inline pb-2">
                  <input type="checkbox" (change)="SelectAllKeywords()" [(ngModel)]="SelectAllStatus"
                         [value]="SelectAllStatus" [disabled]="disableStopKeywords || disableSelectAll"
                         name="category-option" />
                  <span>Select All</span>
                </label>
                <button type="button" class="imo-btn-delete"
                        [disabled]="disableStopKeywords || disableDelete" (click)="DeleteAllKeywords()">
                  <img src="assets/images/delete-alt.svg" alt="Delete" class="pr-2" />
                  <span>Delete</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center border-0 iom-modewhite">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                (click)="CancelIgnoreKeywords()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" [disabled]="disableStopKeywords || !EnableSave"
                (click)="SaveIgnoreKeywords()" data-bs-dismiss="modal">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="RecategorizeModel" tabindex="-1" role="dialog" aria-labelledby="Recategorize" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Edit Category</h5>
                <button id="btnRecategorizeModelClose" type="button" data-bs-dismiss="modal" hidden></button>
                <button type="button" (click)="CloseRecategorizeModel()" class="close editCatModelClose"
                    data-bs-dismiss="modal" aria-label="Close">
                    <span style="cursor: pointer;" aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row col-md-12">
                        <div class="form-group col-md-10"><label class="form-label">Edit Category
                                Name</label>
                                <input [(ngModel)]="CategoryObj.CategoryName" (keyup)=" OnKeyupCategoryname()"
                                [value]="CategoryObj.CategoryName" type="text" placeholder="Enter the Category Name"
                                class="form-control" (keypress)="OnKeypressIncludeSpace($event)" [readonly]="IsFDSReadonly || !IsProcessEnabled">
                        </div>
                        <div class="form-group mb-0 col-md-1" style="margin-top: 25px;"><button type="button"
                                [disabled]="IsFDSReadonly" (click)="KmeansCategoryEdit()" class="btn btn-primary"><span
                                    class="text-nowrap">Save</span></button></div>
                    </div>
                    <div style="margin-left: -15px;margin-top: 15px;">
                        <h5>Re Categorize</h5>
                    </div>
                    <div class="row col-md-12" style="margin-top: 25px;">
                        <div class="form-group col-md-6"><label class="form-label">No of Cluster</label><input
                                (keyup)="OnKeyupClusters_CategoryLevel()" type="text" [readonly]="IsFDSReadonly || !IsProcessEnabled"
                                [(ngModel)]="CategoryObj.No_Cluster" [value]="CategoryObj.No_Cluster"
                                placeholder="Enter Cluster" class="form-control"></div>
                        <!-- <div *ngIf="userType != 3" class="form-group col-md-6"><label class="form-label">Exit
                                Criteria</label><input (keyup)="OnKeyupExitCondition_CategoryLevel(false)" type="text"
                                [readonly]="IsFDSReadonly" [(ngModel)]="CategoryObj.ExitCondition"
                                [value]="CategoryObj.ExitCondition" placeholder="Enter Exit Criteria"
                                class="form-control"></div> -->
                        <div class="form-group col-md-6"><label class="form-label"
                                style="width:21rem">Allowed
                                maximum
                                % of unclassified tickets</label><input
                                (keyup)="OnKeyupExitCondition_CategoryLevel(true)" type="text"
                                [readonly]="IsFDSReadonly || !IsProcessEnabled" [(ngModel)]="CategoryObj.ExitCondition"
                                [value]="CategoryObj.ExitCondition"
                                placeholder="Enter allowed max % of unclassified tickets" class="form-control">
                        </div>
                    </div>
                    <div class="form-group mb-0 d-flex justify-content-center"><button
                            [disabled]="!CategoryObj.ReCategorizeEnabled || !reenabled || !IsProcessEnabled" type="button" (click)="SaveReCategorize()"
                            class="btn btn-secondary"><img src="assets/images/category.svg" alt="Re Categorize"><span
                                class="text-nowrap">Re Categorize</span></button></div>
                </div>
            </div>
        </div>
    </div>
</div>